/** Colours used to render parsed graph node types in the P&ID / PFD editor and exports. */
export const NODE_TYPE_COLORS = {
  symbol: '#2424ff',
  tag: '#48FC40',
  instrument_symbol: '#A855F7',
  connection: '#FF0000',
  // Table cells, shown only while the Tables panel is open — so this teal reads as "the
  // table you are editing" rather than a detected class.
  table_cell: '#0891B2',
  highlighted: '#F59E0B',
  searchMatch: '#FCD34D',
  // HITL Review layer (PRD "Vision HITL Labeling"): flagged low-confidence items
  // render in this one hot color, used nowhere else in the app; every other
  // detection is muted to the neutral grey so the rare cases stand alone.
  review: '#FF6A00',
  reviewMuted: '#9CA3AF',
} as const
